export default class WorkOrderType {
    public id: string = "";

    /** Name of the type to be displayed on the UI. */
    public name: string = "";

    /** If true, the type cannot be added to tasks. */
    public disabled: boolean = false;

    /** If true, this is the internal type used for absence work orders. */
    public isAbsence: boolean = false;

    public isWorkOrderType: boolean = true;
}